module.exports = __webpack_public_path__ + "static/img/demoadd.ce6dbd57.png";